// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2NftM","log":"ModalInventoryLogs_log__1Q2-s","date":"ModalInventoryLogs_date__1iPlk","userName":"ModalInventoryLogs_userName__1ssUU"};